import {
  set
} from '../redux/activities'
import _requestAddBookmark from 'store/sagas/requestAddBookmark'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  activityId: number
}

export default (payload: Payload) => async dispatch => {
  const { cardId, activityId } = payload

  const optimisticAction = optimisticDispatch(dispatch, set({
    cardId,
    activity: {
      id: activityId,
      isBookmarked: true
    }
  }))

  try {
    await dispatch(_requestAddBookmark({
      id: activityId,
      contextTag: 'card-' + cardId
    }))

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}
